import ApiBase from "./base";
import { jsonToQueryString } from '../shared/utils';
import { toast } from 'react-toastify';
import i18n from "../translations";

export const _DRIVER_URL = "driver";

export async function getDriverList(params) {
    const response = await ApiBase.get(`${_DRIVER_URL}?${jsonToQueryString(params)}`);

    return response;
}

export async function getDriverDetail(id) {
    const response = await ApiBase.get(`${_DRIVER_URL}/${id}`);

    return response;
}

export async function updateDriverServiceArea(id, serviceArea) {
    const response = await ApiBase.patch(`${_DRIVER_URL}/${id}/service-area`, { serviceArea });
    if (response.success) toast.success(i18n.t("SUCCESS_TO_UPDATE_DRIVER_SERVICE_AREA"));

    return response;
}